import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { saveRecord } from '../store/brands/actions';

@Component({
    template: `
        <div class="modal-header">
            <h4 class="modal-title">{{ record ? 'Modifica' : 'Nuovo' }} brand</h4>
        </div>
        <div class="modal-body">
            <form [formGroup]="form" (submit)="submitHandler($event)">
                <div class="row form-group">
                    <label class="col-form-label">Nome</label>
                    <div class="control-input">
                        <input class="form-control" type="text" formControlName="name" [ngClass]="{'is-invalid': errors?.name }">
                        <span *ngIf="errors?.name"
                              class="invalid-feedback"
                              role="alert">
                    {{ errors?.name[0] }}
                </span>
                    </div>
                </div>
            </form>

        </div>
        <div class="modal-footer">
            <button class="btn btn-default" (click)="modal.dismiss()">Chiudi</button>
            <button class="btn btn-primary" [disabled]="form.invalid" (click)="submitHandler($event)">Salva</button>
        </div>
    `
})

export class BrandModalComponent implements OnInit {
    public record = null;
    public errors = null;
    form: FormGroup;

    constructor(
        fb: FormBuilder,
        public modal: NgbActiveModal,
        private store: Store
    ) {
        this.form = fb.group({
            id: fb.control(null),
            name: fb.control(null, [Validators.required])
        });
    }

    ngOnInit(): void {
        if (this.record) {
            this.form.patchValue(this.record);
        }
    }

    submitHandler(e) {
        this.store.dispatch(saveRecord({ record: this.form.value }))
    }
}
